import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";
import { IOption } from "Dashboard/domain/IOption";

export function getVatRatePresentation(vatRate: number): string {
  if (vatRate === 0 || vatRate === undefined) {
    return '/';
  }
  return `${vatRate}%`;
}

const VatSelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const [value, setValue] = useState<IOption | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      const vats = [0, 10, 20]
      const op = vats.map((vat) => {
        return {
          label: getVatRatePresentation(vat),
          value: vat,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, []);

  useEffect(() => {
    const values = options.filter((o) => o.value === props.value);
    if (values[0]) {
      setValue(values[0]);
    } else {
      setValue(undefined);
    }
  }, [options, props.value]);

  const handleChange = (newValue: any, actionMeta: any) => {
    setValue(newValue);
    props.onChange(newValue ? newValue.value : null);
  };

  return (
    <Select
      isClearable={props.isClearable !== false}
      styles={props.customStyles}
      menuPosition="fixed"
      ref={ref}
      options={options}
      value={value}
      onChange={handleChange}
      placeholder={""}
      noOptionsMessage={() => "Ne postoji"}
      isLoading={isLoading}
      isDisabled={props.isDisabled === true}
      {...{ error: props.error }}
    />
  );
});

export default VatSelect;
